import Indicator, { IndicatorType } from '../types/Indicator'

const PivotPoints: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'pivotPoints',
  label: 'Pivot Points',
  nickname: 'Pivot Points',
  fields: [
    'pivot',
    'resistance1',
    'resistance2',
    'resistance3',
    'support1',
    'support2',
    'support3',
  ],
  params: {
    pivotPointType: 'standard',
    pivotPointContinuous: false,
  },
}

export default PivotPoints
